<template>
	<div
		class="one-slot-offer-card-detail template-layout premium-shop-item__content"
	>
		<div class="premium-shop-item__character-wrapper">
			<div
				class="premium-shop-item__character-image"
				:class="`character--${contentData.attributes?.skin}-140`"
			/>
		</div>
		<div
			class="premium-shop-item__values"
			:class="{
				'premium-shop-item__values--offset-right':
					hasPercentageDiscount,
			}"
		>
			<ResourceOrUtilityRewardsGrid
				:items="slotItems"
				:context="RewardsGridContext.CARD"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import ResourceOrUtilityRewardsGrid from "@/components/shop/blocks/parts/ResourceOrUtilityRewardsGrid.vue";
import type { ResourceOrUtilitySlotItem } from "@/types/shop";
import { type ShopItem } from "@/types/shop";
import { RewardsGridContext } from "@/types/ui";
import { computed } from "vue";

interface Props {
	contentData: ShopItem;
}

const { contentData } = defineProps<Props>();

const slotItems = computed(
	(): Array<ResourceOrUtilitySlotItem> | null =>
		(contentData.attributes?.slots?.[0]
			?.items as Array<ResourceOrUtilitySlotItem>) ?? null,
);

const hasPercentageDiscount = computed(
	(): boolean =>
		!!contentData.attributes.percentage_discount &&
		contentData.attributes.percentage_discount > 0,
);
</script>

<style lang="scss" scoped>
.premium-shop-item__content {
	position: relative;
	flex: 1 1 auto;
	width: 100%;
	min-height: 0;
	@include flex-row-center;
	align-items: flex-end;
	height: 100%;

	.premium-shop-item {
		&__character {
			&-wrapper {
				position: relative;
				flex: 0 0 auto;
				width: 8.5rem;
				height: 9.5rem;
			}

			&-image {
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}

		&__values {
			flex: 1 1 auto;
			@include flex-col-center;
			justify-content: flex-start;
			padding-bottom: 2.5rem;
			height: 100%;
			overflow: hidden;

			&--offset-right {
				padding-right: 1.625rem;
			}

			.rewards-grid {
				width: 100%;
			}
		}
	}
}
</style>
